'use client';
import { makeStyles } from '@fluentui/react-components';
export const useAttachmentBodyStyles = makeStyles({
    root: {
        flex: '1 1 0'
    }
});
